import React, { useEffect, useContext } from 'react';
import AuthContext from '../../../context/authContext';
import { changeInitialScale, projectView } from '../../../myfunctions';


function Dashboard() {
  const authContext = useContext(AuthContext);

 
  useEffect(() => {
   
    if(authContext && authContext.gView==="Duel1vs1"){
      changeInitialScale(0.7) 
    }else{
      changeInitialScale(0.5) 
    }

    
    return () => { changeInitialScale(1) }; // use effect cleanup to set flag false, if unmounted
  }, [authContext.gView])// eslint-disable-line react-hooks/exhaustive-deps



  return (
    <div style={{ position: "relative",marginLeft:30,marginRight:30 }} >
      {projectView(authContext.gView)}
    </div>

  )
}

export default Dashboard;